module.exports = __webpack_public_path__ + "static/media/chevron.5b584a20.svg";